export default __webpack_public_path__ + "static/media/comingtoamerica.6e9b1f03.jpg";